<template>
  <div class="merchantRejected">
    <div class="subpage-header">
      <h2 class="normal" id="page-title-for-sr">
        <span class="sr-only">{{ $t('confirmation.pageTitle') }}: </span>
        <span aria-live="assertive" role="status" v-html="$t('confirmation.merchantRejected.header')"></span>
      </h2>
    </div>
    <p v-html="$t('confirmation.merchantRejected.description')"></p>
  </div>
</template>
<script>
export default {
  name: 'ConfirmationMerchantRejected'
}
</script>
